import { Controller } from '@hotwired/stimulus';
import $ from 'jquery';
import { useDebounce } from 'stimulus-use';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static targets = [
        'cancelButton',
        'submitButton',
        'specialismCheckbox',
        'keywordCheckbox',
        'specialismContainer',
        'keywordContainer',
        'errorContainer',
        'searchInput',
        'searchCloseButton',
        'specialismCollapse',
        'noResultsContainer'
    ];

    maxAllowedSelection = 3;

    static debounces = ['search'];


    connect() {
        useDebounce(this);

        this.createSearchIndex();

        window.resetState = this.resetState.bind(this);

        $(this.element).on('hidden.bs.modal', () => {
            this.resetState();
        });
    }

    openModal() {
        $(this.element).modal({
            backdrop: 'static',
            focus: false,
            show: true,
        });
    }

    closeModal() {
        $(this.element).modal('hide');
    }

    resetState() {
        this.searchInputTarget.value = '';

        this.search();

        this.specialismCheckboxTargets.forEach(checkbox => {
            checkbox.checked = 'true' === checkbox.dataset.initialState;
        });

        this.keywordCheckboxTargets.forEach(checkbox => {
            checkbox.checked = 'true' === checkbox.dataset.initialState;
        });

        this.specialismCollapseTargets.forEach(collapse => {
            const shouldBeOpen = 'true' === collapse.dataset.initialState;

            this.changeCollapse(collapse, shouldBeOpen ? 'show' : 'hide');
        });

        this.submitButtonTarget.disabled = false;
        this.cancelButtonTarget.disabled = false;

        this.keywordContainerTargets.forEach(container => {
            $(container).show();
        });
    }

    async submitForm() {
        this.submitButtonTarget.disabled = true;
        this.cancelButtonTarget.disabled = true;

        showPreloader();

        // get selected specialisms and keywords
        const specialismIds = this.specialismCheckboxTargets.filter(checkbox => checkbox.checked).map(checkbox => checkbox.value);
        const keywordsIds = this.keywordCheckboxTargets.filter(checkbox => checkbox.checked).map(checkbox => checkbox.value);

        const selectedIds = [...specialismIds, ...keywordsIds];

        if (selectedIds.length > this.maxAllowedSelection) {
            return;
        }

        const url = routes['app_profile_edittop3specialismsandkeywords'];
        const specialismKeywordData = {
            field: 'top_3_specialisms_keywords',
            value: selectedIds.join(','),
        };

        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
                    'X-Requested-With': 'XMLHttpRequest',
                },
                body: new URLSearchParams(specialismKeywordData),
            });

            const result = await response.json();

            if (result.status) {
                dataLayer.push({
                    event: 'dataLayer.gaEvent',
                    gaEvent: {
                        'category': 'Account',
                        'action': 'profile_topspecialisms_success',
                        'label': GA_EVENT_LABEL,
                    },
                });

                setTimeout(() => {
                    window.location.reload();
                }, 300);

                addAlert('success', result.message);
                return;
            } else {
                addAlert('danger', translations['profile.An unknown error occurred.']);
            }
        } catch (error) {
            console.log(error);

            addAlert('danger', translations['profile.An unknown error occurred.']);
        }

        this.submitButtonTarget.disabled = false;
        this.cancelButtonTarget.disabled = false;

        hidePreloader();
    }

    search(event) {
        // search all the specialismsNames, specialismsNamesNormalized, keywordsNames, keywordsNamesNormalized objects for a match and find specialism or keywords ids that match with the input value
        const searchValue = this.searchInputTarget.value.toLowerCase();

        if (searchValue === '') {
            this.searchCloseButtonTarget.style.display = 'none';

            this.specialismContainerTargets.forEach(container => {
                container.style.removeProperty('display');
            });

            if ('undefined' === typeof event) {
                return;
            }

            this.specialismContainerTargets.forEach(container => {
                if ($(container).find('[id^="top-3-specialism-collapse-"]').length > 0) {
                    const shouldBeOpen = 'true' === $(container).find('[id^="top-3-specialism-collapse-"]')[0].dataset.initialState;

                    this.changeCollapse($(container).find('[id^="top-3-specialism-collapse-"]')[0], shouldBeOpen ? 'show' : 'hide');
                }
            });

            return;
        }

        this.searchCloseButtonTarget.style.removeProperty('display');

        if (searchValue.length < 3) {
            return;
        }

        const specialismsToShowFully = [];
        const specialismsToShowWithKeywordsHidden = [];
        const keywordsToShow = [];

        this.specialismsNames.forEach(specialism => {
            if (specialism.value.includes(searchValue)) {
                if (!specialismsToShowFully.includes(specialism.id)) {
                    specialismsToShowFully.push(specialism.id);
                }
            }
        });

        this.specialismsNamesNormalized.forEach(specialism => {
            if (specialism.value.includes(searchValue)) {
                if (!specialismsToShowFully.includes(specialism.id)) {
                    specialismsToShowFully.push(specialism.id);
                }
            }
        });

        this.keywordsNames.forEach(keyword => {
            if (keyword.value.includes(searchValue)) {
                if (specialismsToShowFully.includes(keyword.specialismId)) {
                    return;
                }

                if (!specialismsToShowWithKeywordsHidden.includes(keyword.specialismId)) {
                    specialismsToShowWithKeywordsHidden.push(keyword.specialismId);
                }

                if (!keywordsToShow.includes(keyword.id)) {
                    keywordsToShow.push(keyword.id);
                }
            }
        });

        this.keywordsNamesNormalized.forEach(keyword => {
            if (keyword.value.includes(searchValue)) {
                if (specialismsToShowFully.includes(keyword.specialismId)) {
                    return;
                }

                if (!specialismsToShowWithKeywordsHidden.includes(keyword.specialismId)) {
                    specialismsToShowWithKeywordsHidden.push(keyword.specialismId);
                }

                if (!keywordsToShow.includes(keyword.id)) {
                    keywordsToShow.push(keyword.id);
                }
            }
        });

        this.specialismContainerTargets.forEach(container => {
            const specialismId = container.dataset.specialismId;

            if (specialismsToShowFully.includes(specialismId)) {
                container.style.removeProperty('display');
                this.changeCollapse($(container).find('[id^="top-3-specialism-collapse-"]')[0], 'show');
                $(container).find('[data-profile--edit-top-3-specialisms-and-keywords-modal-target="keywordContainer"]').show();
            } else if (specialismsToShowWithKeywordsHidden.includes(specialismId)) {
                container.style.removeProperty('display');
                this.changeCollapse($(container).find('[id^="top-3-specialism-collapse-"]')[0], 'show');
                $(container).find('[data-profile--edit-top-3-specialisms-and-keywords-modal-target="keywordContainer"]').hide();
            } else {
                container.style.display = 'none';
                this.changeCollapse($(container).find('[id^="top-3-specialism-collapse-"]')[0], 'true' === container.dataset.initialState ? 'show' : 'hide');
                $(container).find('[data-profile--edit-top-3-specialisms-and-keywords-modal-target="keywordContainer"]').show();
            }
        });

        this.keywordContainerTargets.forEach(container => {
            const keywordId = container.dataset.keywordId;

            if (keywordsToShow.includes(keywordId)) {
                $(container).show();
            }
        });

        if (
            0 === specialismsToShowFully.length
            && 0 === specialismsToShowWithKeywordsHidden.length
            && 0 === keywordsToShow.length
        ) {
            $(this.noResultsContainerTarget).show();
        } else {
            $(this.noResultsContainerTarget).hide();
        }
    }

    createSearchIndex() {
        this.specialismsNames = this.specialismCheckboxTargets.map(checkbox => ({
            id: checkbox.value,
            value: checkbox.dataset.name,
        }));
        this.specialismsNamesNormalized = this.specialismCheckboxTargets.map(checkbox => ({
            id: checkbox.value,
            value: checkbox.dataset.normalizedName,
        }));
        this.keywordsNames = this.keywordCheckboxTargets.map(checkbox => ({
            id: checkbox.value,
            value: checkbox.dataset.name,
            specialismId: checkbox.dataset.specialismId,
        }));
        this.keywordsNamesNormalized = this.keywordCheckboxTargets.map(checkbox => ({
            id: checkbox.value,
            value: checkbox.dataset.normalizedName,
            specialismId: checkbox.dataset.specialismId,
        }));
    }

    checkForSelectedLimit() {
        const selectedCountSpecialism = this.specialismCheckboxTargets.filter(checkbox => checkbox.checked).length;
        const selectedCountKeywords = this.keywordCheckboxTargets.filter(checkbox => checkbox.checked).length;
        const selectedCount = selectedCountSpecialism + selectedCountKeywords;
        const allowedCount = this.maxAllowedSelection;

        if (selectedCount > allowedCount) {
            $(this.errorContainerTarget).show();

            this.submitButtonTarget.disabled = true;
        } else {
            $(this.errorContainerTarget).hide();

            this.submitButtonTarget.disabled = false;
        }
    }

    expandSpecialismIfNeeded(event) {
        const checkbox = event.target;

        if (checkbox.checked) {
            const specialismId = checkbox.dataset.specialismId;
            const $specialismCollapse = $('#top-3-specialism-collapse-' + specialismId);

            if ($specialismCollapse.length > 0) {
                this.changeCollapse($specialismCollapse[0], 'show');
            }
        }
    }

    clearSearch() {
        this.searchInputTarget.value = '';
        this.searchCloseButtonTarget.style.display = 'none';

        this.search();
    }

    changeCollapse(element, state) {
        const $element = $(element);
        const isOpen = $element.hasClass('show');

        if ('show' === state && isOpen) {
            return;
        }

        if ('hide' === state && !isOpen) {
            return;
        }

        $element.collapse(state);
    }
}
